import StarterKit from "./StarterKit";

import Header from "./components/Header";
import NavsFull from "./components/NavsFull";
import NavsBurger from "./components/NavsBurger";

import BlockBanner from "./blocks/BlockBanner";
import BlockCollapse from "./blocks/BlockCollapse";
import BlockGallery from "./blocks/BlockGallery";
import BlockGallerySlider from "./blocks/BlockGallerySlider";
import BlockGallerySliderSimple from "./blocks/BlockGallerySliderSimple";
import BlockMap from "./blocks/BlockMap";
import BlockMovie from "./blocks/BlockMovie";
import BlockQuotes from "./blocks/BlockQuotes";
import BlockSlider from "./blocks/BlockSlider";
import BlockSliderScrollable from "./blocks/BlockSliderScrollable";
import BlockScrollingText from "./blocks/BlockScrollingText";

import Share from "./components/Share";
import Banner from "./components/Banner";
import BlockKeyNumbers from "./blocks/BlockKeyNumbers";
import BannerAnimation from "./components/BannerAnimation";

window.initMap = function(){
	window.dispatchEvent(new Event('googleMapApiLoaded'));
};

document.addEventListener("DOMContentLoaded", function () {
	// Starterkit
	StarterKit.init();

	// Components
	Banner.init();
	BannerAnimation.init();
	Header.init();
	NavsFull.init();
	NavsBurger.init();

	// Blocks
	BlockBanner.init();
	BlockCollapse.init();
	BlockGallery.init();
	BlockGallerySlider.init();
	BlockGallerySliderSimple.init();
	BlockKeyNumbers.init();
	BlockMap.init();
	BlockMovie.init();
	BlockQuotes.init();
	BlockSlider.init();
	BlockScrollingText.init();
	BlockSliderScrollable.init();

	Share.init();
});
